export default __webpack_public_path__ + "static/media/mobile.f704a7bd.jfif";